import React from 'react'
import * as actions from '../redux/actions'
import { connect } from 'react-redux'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Modal, Button, Row, Col, Form } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";


class Ads extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            calendarEvents: [ // initial event data
                { title: 'Event Now', start: new Date() }
            ],
            eventTime: null,
            showModal: false,
            entities: null
        }
        this.handleDateClick = this.handleDateClick.bind(this);
        this.refCalendar = React.createRef()
    }
    componentWillMount() {
        console.log("ee")
        this.props.getEntities().then((res) => {
            console.log(res.results)
            this.setState({ entities: res.results })
        })
    }
    handleDateClick = (arg) => {
        console.log(arg)
        this.setState({
            //eventTime: arg.dateStr
            eventTime: new Date(arg.dateStr).toISOString(),
            showModal: true
        })
    }

    handleClose = () => {
        this.setState({
            showModal: false
        })
    }

    render() {
        console.log(this.refCalendar)
        return (
            <div className="App">
                <h1>Ads</h1>

                <FullCalendar
                    ref={this.refCalendar}
                    defaultView="dayGridMonth"
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    // onClick={(arg) => this.handleDateClick(arg)}
                    events={this.state.calendarEvents}

                    dateClick={(arg) => this.handleDateClick(arg)} />
                <Modal show={this.state.showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Schedule Ad</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Row>
                                    <Col>
                                        <Form.Label>Ad Time</Form.Label>
                                    </Col>
                                    <Col>
                                        <DatePicker
                                            showTimeSelect
                                            value={this.state.eventTime}
                                            dateFormat="MM-DD-YYYY" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect1">
                                <Row>
                                    <Col>
                                        <Form.Label>Entity</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            {this.state.entities && this.state.entities.map(entity =>
                                                <option key={entity.id}>
                                                    {entity.internal_entities_name}
                                                </option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect2">
                                <Row>
                                    <Col>
                                        <Form.Label>Campaign</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect3">
                                <Row>
                                    <Col>
                                        <Form.Label>Ad</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <hr />
                            <Form.Group controlId="exampleForm.ControlSelect3">
                                <Row>
                                    <Col>
                                        <Form.Label>Post Type</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect3">
                                <Row>
                                    <Col>
                                        <Form.Label>Post Category</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect3">
                                <Row>
                                    <Col>
                                        <Form.Label>Title</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                <Form.Label>Post Body</Form.Label>
                                <Form.Control as="textarea" rows="3" size="sm" />
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect4">
                                <Row>
                                    <Col>
                                        <Form.Label>Contact Name</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect4">
                                <Row>
                                    <Col>
                                        <Form.Label>Phone Number</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect4">
                                <Row>
                                    <Col>
                                        <Form.Label>Specific Location</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect4">
                                <Row>
                                    <Col>
                                        <Form.Label>Street</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect4">
                                <Row>
                                    <Col>
                                        <Form.Label>Cross Street</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect3">
                                <Row>
                                    <Col>
                                        <Form.Label>City</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect3">
                                <Row>
                                    <Col>
                                        <Form.Label>City Best Fit Location</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control as="select" size="sm">
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect4">
                                <Row>
                                    <Col>
                                        <Form.Label>Postal Code</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Control type="text" size="sm" />
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>Close</Button>
                        <Button variant="primary">Save</Button>
                    </Modal.Footer>
                </Modal>;
            </div>
        );
    }
}


function mapStateToProps({ auth, ads }) {

    return {

    };
}
export default connect(mapStateToProps, actions)(Ads);
